import {BaseAppPrefs} from "@/shared/BaseAppPrefs";

export abstract class BaseElementsAppPrefs extends BaseAppPrefs {

  protected constructor() {
    super();
  }

  static readonly PREF_SELECTED_PRACTICE_ID = "sel_prac_id";

  getSelectedPracticeId(): string | null {
    return this.prefs.getString(BaseElementsAppPrefs.PREF_SELECTED_PRACTICE_ID);
  }

  setSelectedPracticeId(id: string): void {
    this.prefs.setString(BaseElementsAppPrefs.PREF_SELECTED_PRACTICE_ID, id);
  }
}
